(function($) {

    'use strict';

    var Login = function(element, options) {
        this.$element = $(element);
        this.options = options;

        this.$form = this.$element.closest('form');
        this.$email = this.$form.find('[data-login-validate-email]');
        this.$birthDay = this.$form.find('[data-social-birth-day] ');
        this.$birthMonth = this.$form.find('[data-social-birth-month]');
        this.$birthYear = this.$form.find('[data-social-birth-year]');
        this.$gender = this.$form.find('[data-social-gender]');
        this.$stateRegister = this.$form.find('[data-login-state-registration]');
        this.$stateRegisterExempt = this.$form.find('[data-login-check-state-registration]');
    };

    Login.DEFAULTS = {
        'legalPerson': '1',
        'naturalPerson': '2'
    };

    Login.prototype.validateLogin = function() {
        this.$email.val($.trim(this.$email.val()));
        this.validateEmail();

        if (this.isLoginValid() === false) {
            this.setAsInvalid(this.$element);
        }
    };

    Login.prototype.validateEmail = function() {
        this.$element.removeClass('is-valid').removeClass('is-invalid');
        this.$form.find('.errorMessage').remove();

        if (this.isLoginValid()) {
            this.setAsValid(this.$element);
        }
    };

    Login.prototype.isLoginValid = function() {
        var isEmailValid = /\S+@\S+\.\S+/.test(this.$email.val());
        var isCPFvalid = this.$email.val().replace(/[^0-9]/g, '').length === 11;

        if (this.$form.data('login-validate') === 'create') {
            isCPFvalid = false;
        }

        return (isEmailValid || isCPFvalid);
    };

    Login.prototype.changePersonType = function() {
        var form = this.$element.closest('form');
        var naturalPerson = form.find('[data-form-group="natural"]');
        var legalPerson = form.find('[data-form-group="legal"]');

        if (this.$element.val() == this.options.naturalPerson) {
            this.removeValidation(legalPerson);
            this.showValidation(naturalPerson);
            this.changeTaxIdentification('CPF');
        } else {
            this.removeValidation(naturalPerson);
            this.showValidation(legalPerson);
            this.changeTaxIdentification('CNPJ');
        }
    };

    Login.prototype.removeValidation = function(element) {
        element.attr('disabled', 'disabled');
        element.closest('[data-login-person-type-container]').hide();
    };

    Login.prototype.showValidation = function(element) {
        element.removeAttr('disabled');
        element.closest('[data-login-person-type-container]').show().removeClass('hide');
    };

    Login.prototype.toggleStateRegistration = function(element, forceDisabled) {
        var form = this.$element.closest('form');
        var isDisabled = (this.$element.is(':checked') || forceDisabled) ? 'disabled' : false;

        form.find('[data-login-state-registration]').attr('disabled', isDisabled);
        if (form.find('[data-login-state-registration]').hasClass('parsley-error')) {
            form.find('[data-login-state-registration]').toggleClass("is-invalid");
            form.find('[data-login-state-registration]').siblings('.parsley-errors-list').toggleClass('hide');
        }
    };

    Login.prototype.changeTaxIdentification = function(type) {
        var form = this.$element.closest('form');

        var name = form.find('[data-login-name]');
        var taxIdentification = form.find('[data-login-tax-identification]');
        var taxIdentificationLabel = form.find('[data-login-tax-identification-label]');

        if (type === 'CPF') {
            name.text('Nome');
            VMasker(taxIdentification).maskPattern('999.999.999-99');
            taxIdentificationLabel.text(type);
        } else {
            name.text('Razão social');
            VMasker(taxIdentification).maskPattern('99.999.999/9999-99');
            taxIdentificationLabel.text(type);
        }
    };

    Login.prototype.validateBirthday = function() {
        var yearId = this.$birthYear.attr('data-form-id');
        $('#parsley-id-' + this.$birthDay.attr('data-form-id')).remove();
        $('#parsley-id-' + this.$birthMonth.attr('data-form-id')).remove();
        if (this.$birthDay.val() == 0 || this.$birthMonth.val() == 0 || this.$birthYear.val() == 0) {
            $('#parsley-id-' + this.$birthYear.attr('data-form-id')).remove();
            if(this.$birthYear.parents('.parsley-birthday').length) {
                this.$birthYear.parents('.parsley-birthday').append('<ul class="parsley-errors-list filled parsley-errors-birthday" id="parsley-id-' + yearId + '"><li class="parsley-required">Preencha os campos de data</li></ul>');            
            } else{
                this.$birthYear.parent().parent().append('<ul class="parsley-errors-list filled" id="parsley-id-' + yearId + '"><li class="parsley-required">Preencha os campos de data</li></ul>');            
            }
        }
    };

    Login.prototype.validateStateRegister = function() {
        var errorId = this.$stateRegister.attr('data-form-id')
        $('#parsley-id-' + errorId).remove();
        if (this.$stateRegister.val() == '' && !this.$stateRegisterExempt.prop("checked")) {
            $('.auth-form-state-registration').append('<ul class="parsley-errors-list filled" id="parsley-id-' + errorId + '"><li class="parsley-required">Campo obrigatório</li></ul>');
        }
    };

    Login.prototype.validateGender = function() {
        var errorId = this.$gender.attr('data-form-id');
        $('#parsley-id-' + errorId).remove();
        if (this.$gender.val() == '') {
            $('[data-gender-box]').append('<ul class="parsley-errors-list filled" id="parsley-id-' + errorId + '"><li class="parsley-required">Campo obrigatório</li></ul>');
        }
    }

    Login.prototype.setAsInvalid = function(element) {
        element.removeClass('is-valid').addClass('is-invalid');
    };

    Login.prototype.setAsValid = function(element) {
        element.removeClass('is-invalid').addClass('is-valid');
    };

    Login.prototype.emailExists = function() {
        $(document).trigger('dft.events-monitoring');

        var params = {
            'email': this.$email.val(),
            'page': 'checkout',
            'b2014': 1
        };

        if (this.isLoginValid() === false) {
            this.setAsInvalid(this.$email);
            this.addErrorMessage(i18n.invalidEmail);
            return;
        }

        $.ajax({
            'url': '/checkout/index/CheckEmailExist/',
            'dataType': 'json',
            'data': params,
            'complete': $.proxy(this, 'loaded')
        });
    };

    Login.prototype.loaded = function(response) {
        var data = JSON.parse(response.responseText);
        var shouldRedirectToCheckout = window.location.pathname.indexOf('checkout');

        if (data.response === false && shouldRedirectToCheckout > 0) {
            return window.location.href = '/checkout/finish';
        }

        if (data.template) {
            this.setAsInvalid(this.$email);

            // email exists on database
            $('body').modal('destroy');
            $('body').removeData('dft.modal');
            $('body').modal({ 'innerClassName': 'modal-email-exists', 'content': data.template });
        }
    };

    Login.prototype.addErrorMessage = function(message) {
        if (this.$form.find('.errorMessage').length === 0) {
            this.$email.after('<div class="errorMessage">' + message + '</div>');
        }
    };

    Login.prototype.forceLegalPerson = function() {
        var isLegalPerson = $('#RegistrationForm_customer_personality_1').is(':checked');

        if (isLegalPerson) {
            this.changePersonType();
            this.toggleStateRegistration(this.$element, true);
        }
    };

    Login.prototype.clearForm = function(message) {
        var elements = this.$element.siblings('.auth-form-box');

        elements.find('[data-login-validate-email]').val('');
        elements.find('[data-login-validate-password]').val('');
        elements.find('.is-invalid').remove();
        elements.find('.is-valid').remove();
        elements.find('.description-error').remove();
        elements.find('.error').removeClass('error');
        elements.find('.errorMessage').remove();
    };

    $.fn.login = function(option, args) {
        return this.each(function() {
            var $this = $(this);
            var data = $this.data('dft.login');
            var options = $.extend({}, Login.DEFAULTS, $this.data(), typeof option == 'object' && option);

            if (!data) $this.data('dft.login', (data = new Login(this, options)));
            if (typeof option == 'string') data[option](args);
        });
    };

    $(document).on('input paste, keyup', '[data-login-validate-email]', function(e) {
        $(this).login('validateEmail');
    });

    $(document).on('blur', '[data-login-validate-email]', function(e) {
        $(this).login('validateLogin');
    });

    $(document).on('change', '[data-social-birth-year]', function(e) {
        $(this).login('validateBirthday');
    });

    $(document).on('change', '[data-login-state-registration]', function(e) {
        $(this).login('validateStateRegister');
    });

    $(document).on('change', '[data-social-gender]', function(e) {
        $(this).login('validateGender');
    });

    $(document).on('submit', '[data-login-validate="create"]', function(e) {
        e.preventDefault();
        $(this).login('emailExists');
    });

    $(document).on('submit', '[data-login-validate="createLogin"]', function(e) {
        $(this).login('validateBirthday');
        $(this).login('validateStateRegister');
        $(this).login('validateGender');
    });

    $(document).on('click', '[data-login-check-state-registration]', function(e) {
        $(this).login('toggleStateRegistration');
    });

    $(document).on('change', '[data-login-person-type]', function(e) {
        $(this).login('changePersonType');
    });

    $(document).on('click','.password-toggle', function(e) {
        var obj = $('.input-box-password');
        var input = obj.find('input');
        var status = !JSON.parse(obj.attr('show-password'))
        obj.attr('show-password', status)
        input.attr('type', status?'text':'password')
    });

    var selectedOption = "account-form-registered-customer";
    $(document).on('click', 'input[data-accordion-trigger="account"]', function(e) {
        if ($(this).attr('id') == selectedOption) {
            if ($(this).attr('id') == "account-form-registered-customer") {
                selectedOption = 'account-form-new-customer';
                $('#account-form-registered-customer, #account-form-new-customer').prop('checked', false);
                $('#account-form-new-customer').prop('checked', true);
            } else {
                selectedOption = 'account-form-registered-customer';
                $('#account-form-registered-customer, #account-form-new-customer').prop('checked', false);
                $('#account-form-registered-customer').prop('checked', true);
            }
        } else {
            selectedOption = $(this).attr('id');
        }
    });

    $(document).ready(function() {
        VMasker($('[data-login-tax-identification]')).maskPattern('999.999.999-99');
        $("#address-form, #my-account-address-form").on({
            keyup: function() {
                var phone = this.value,
                    digits = phone.replace(/\D/g, '');

                VMasker($(this)).unMask();

                if (digits.length > 9) {
                    VMasker($(this)).maskPattern("(99) 99999-9999");
                } else {
                    VMasker($(this)).maskPattern("(99) 9999-9999");
                }
            },
            keypress: function(e) {
                var unicode = e.charCode ? e.charCode : e.keyCode;
                if (unicode != 8 && unicode != 9) {
                    if (unicode < 48 || unicode > 57) {
                        return false
                    }
                }
            }
        }, ".mask-phone-number");
        $('#login-account-create').login('forceLegalPerson');
    });

})(jQuery);
